import type { RouteRecordRaw } from 'vue-router'

import { DOCTYPES } from '@/constants/doctypes.ts'
import { HAS_CREATE_VIEW_ONE_PERMISSION_OF } from '@/constants/permissions.ts'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const routeReturnSalesInvoiceCreate: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/salesInvoices/AddReturnSalesInvoice.vue')
  },
  meta: { doctypes: { [DOCTYPES.SALES_INVOICE]: HAS_CREATE_VIEW_ONE_PERMISSION_OF } },
  name: 'new-return-sales-invoice',
  path: 'new-return-sales-invoice',
}

const {
  create: routeSalesInvoiceCreate,
  detail: routeSalesInvoiceDetail,
  home: routeSalesInvoicesHome,
  root: routeSalesInvoicesRoot,
} = createDoctypeRoutes({
  createName: 'new-sales-invoice',
  createPath: 'new-sales-invoice',
  detailName: 'salesInvoiceDetail',
  doctype: DOCTYPES.SALES_INVOICE,
  extraRoutes: [routeReturnSalesInvoiceCreate],
  homeName: 'sales-invoices-home',
  path: 'sales-invoices',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/salesInvoices/AddSalesInvoice.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/salesInvoices/ViewSalesInvoice.vue'),
    list: async () => await import('@/components/viewsExternal/salesInvoices/SalesInvoiceView.vue'),
  },
})

export {
  routeReturnSalesInvoiceCreate,
  routeSalesInvoiceCreate,
  routeSalesInvoiceDetail,
  routeSalesInvoicesHome,
  routeSalesInvoicesRoot,
}
